import HyperguestLayout from './Hyperguest'
export default [
    {
        path: 'hotels_suscription_hyperguest',
        alias: '',
        component: HyperguestLayout,
        redirect: '',
        name: 'Suscripcion Hyperguest',
        meta: {
            breadcrumb: 'Hyperguest'
        },
        children: [

        ]
    }]
